import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";
import type { DigitalAssetType } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { track as TrackFn } from "pro-features/components/WithTrack/src/WithTrack";

export default function createWidgetsTrackingService(track: TrackFn) {
    return {
        trackLinkedinClick(companyName: string, url: string) {
            const eventName = createTrackingEventName("open company linkedin", url, companyName);
            track("company card", "click", eventName);
        },
        trackWebsiteClick(companyName: string, url: string) {
            const eventName = createTrackingEventName("open company website", url, companyName);
            track("company card", "click", eventName);
        },
        trackWidgetFooterButtonClick(companyName: string, widgetName: string) {
            track("company widgets", "click", `open tab/${widgetName}/${companyName}`);
        },
        trackDigitalAssetsDomainClick(companyName: string, domain: string) {
            track("company widgets", "click", `open regional domain analysis/${domain}/${companyName}`);
        },
        trackTechnologiesFilterSelect(companyName: string, category: string) {
            track("company widgets", "click", `filter technology/${category}/${companyName}`);
        },
        trackCompetitorsDomainClick(companyName: string, domain: string) {
            track("company widgets", "click", `view competitor/${domain}/${companyName}`);
        },
        trackAddCompetitorToList(companyName: string, domain: string) {
            track("company widgets", "click", `add competitor to list/${domain}/${companyName}`);
        },
        trackDigitalAssetsTabSwitch(companyName: string, tabName: string) {
            track(
                "company widgets",
                "click",
                createTrackingEventName("switch digital assets tab", companyName, tabName),
            );
        },
        trackDigitalAssetsAppClick(companyName: string, appOs: AppOperatingSystem) {
            track("company widgets", "click", createTrackingEventName("open app", companyName, appOs));
        },
        trackCompanyCardAssetsMoreClick(companyName: string, assetType: DigitalAssetType) {
            track("company card", "click", createTrackingEventName("view more", companyName, assetType));
        },
    };
}
